import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccesoModel, Documento, DocumentoTecnico } from 'src/app/models/queries/accesos/AccessoModel';
import { AccesoPersonaService } from 'src/app/services/acceso-personal/acceso-persona.service';
import * as fileSaver from 'file-saver';
import { SolicitudPersonaDocumentosService } from 'src/app/services/solicitud-persona-documentos/solicitud-persona-documentos.service';
import { SolicitudDocumentosTecnicosService } from 'src/app/services/solicitud-documentos-tecnicos/solicitud-documentos-tecnicos.service';
import { EquipoModel } from 'src/app/models/solicitud/EquipoModel';
import { VehiculoModel } from 'src/app/models/solicitud/VehiculoModel';
import { EquipoReadonlyDialogComponent } from '../../solicitudes/equipo/equipo-readonly-dialog/equipo-readonly-dialog.component';
import { VehiculoReadonlyDialogComponent } from '../../solicitudes/vehiculo/vehiculo-readonly-dialog/vehiculo-readonly-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { VisorPdfDocumentoModel } from 'src/app/models/common/VisorPdfDocumentoModel';
import { SolicitudSeccion } from 'src/app/models/common/enumModel';
import { VisorPdfDialogComponent } from '../../shared/visor-pdf-dialog/visor-pdf-dialog.component';

@Component({
  selector: 'app-acceso-personal',
  templateUrl: './acceso-personal.component.html',
  styleUrls: ['./acceso-personal.component.css']
})
export class AccesoPersonalComponent implements OnInit {
  id: number;
  model: AccesoModel;

  displayedColumns: string[] = [
    'documentoRequerido',
    'requisito',
    'fechaVencimiento',
    'nombreArchivo'
  ];

  displayedColumnsEquipo: string[] = [
    'marca',
    'modelo',
    'serie',
    'estado',
    'acciones'
  ];

  displayedColumnsVehiculo: string[] = [
    'marca',
    'modelo',
    'placa',
    'color',
    'anio',
    'chofer',
    'estado',
    'acciones'
  ];

  displayedColumnsDocumentoTecnico: string[] = [
    'nombre',
    'requisito',
    'fechaVencimiento',
    'nombreArchivo'
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private accesoPersonaService: AccesoPersonaService,
    private solicitudPersonaDocumentoService: SolicitudPersonaDocumentosService,
    private solicitudDocumentosTecnicosService: SolicitudDocumentosTecnicosService,
    public dialog: MatDialog,
  ) {
    this.id = 0;
    this.model = new AccesoModel();
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id = params['id'];
    });

    this.accesoPersonaService.getById(this.id).subscribe((data) => {
      this.model = data;
    });
  }

  downloadDocumentFromService(element: Documento) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.Personal;
      modelVisor.idRegistro = element.idSolicitudPersona;
      modelVisor.idSolicitudDocumento = element.idSolicitudPersonaDocumento;
      modelVisor.codigoSolicitud = this.model.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudPersonaDocumentoService.downloadDocumento(
        this.model.codigoSolicitud,
        element.idSolicitudPersona,
        element.idSolicitudPersonaDocumento
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }

  downloadDocumentoTecnicoFromService(element: DocumentoTecnico) {
    if (element.permiteVisor) {
      let modelVisor: VisorPdfDocumentoModel = new VisorPdfDocumentoModel();
      modelVisor.seccion = SolicitudSeccion.DocumentacionTecnica;
      modelVisor.idSolicitudDocumento = element.idSolicitudDocumentoTecnico;
      modelVisor.codigoSolicitud = this.model.codigoSolicitud;
      modelVisor.nombreArchivo = element.nombreArchivo;
      const dialogVisroRef = this.dialog.open(VisorPdfDialogComponent, {
        width: '1300px',
        data: modelVisor,
        autoFocus: false,
      });
    }
    else {
      this.solicitudDocumentosTecnicosService.downloadDocumento(
        this.model.codigoSolicitud,
        element.idSolicitudDocumentoTecnico
      ).subscribe(data => {
        let blob: any = new Blob([data], { type: 'text/json; charset=utf-8' });
        fileSaver.saveAs(blob, element.nombreArchivo);
      });
    }
  }

  openDialogEquipo(equipo: EquipoModel): void {
    equipo.idSolicitud = this.model.idSolicitud;
    equipo.codigoSolicitud = this.model.codigoSolicitud;

    const dialogRef = this.dialog.open(EquipoReadonlyDialogComponent, {
      width: '1000px',
      data: equipo,
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }

  openDialogVehiculo(vehiculo: VehiculoModel): void {
    vehiculo.idSolicitud = this.model.idSolicitud;
    vehiculo.codigoSolicitud = this.model.codigoSolicitud;

    const dialogRef = this.dialog.open(VehiculoReadonlyDialogComponent, {
      width: '1000px',
      data: vehiculo,
    });

    dialogRef.afterClosed().subscribe((result) => { });
  }
}
